export const MAILTO = "mailto:ashg.skrg@gmail.com?subject=Himalayan%20Actives%20Buyer%20Inquiry";

// Stable placeholder images. We use Unsplash CDN for the hero/berry (large feature shots)
// and deterministic picsum.photos seeds for the carousel so each card is visually distinct
// even when specific Unsplash IDs are unavailable. Replace with real product imagery later.
const u = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;
const p = (seed, w = 600, h = 900) =>
  `https://picsum.photos/seed/${seed}/${w}/${h}`;

export const IMG = {
  hero: "/images/hero-new.jpg",
  berry: u("photo-1574691112613-c1c5cf48708e"),
  facility: u("photo-1581093588401-fbb62a02f120"),
  // Carousel slides — distinct, deterministic placeholders
  pulp: p("ha-pulp"),
  fruitOil: p("ha-fruit-oil"),
  seedOil: p("ha-seed-oil"),
  wholeOil: p("ha-whole-oil"),
  powder: p("ha-powder"),
  dried: p("ha-dried-berries"),
  softgel: p("ha-softgel"),
  gummies: p("ha-gummies"),
  beverage: p("ha-beverage"),
  serum: p("ha-serum"),
};

export const IMG_FALLBACK = p("ha-fallback");
